import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-no-license',
  templateUrl: './no-license.component.html',
  styleUrls: ['./no-license.component.scss']
})
export class NoLicenseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
